import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PublicOrderShipmentContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBeEdited!: boolean;
}
